import React, { useState, useEffect, useCallback } from 'react'
import { DivTag } from '../../../Components/Tags/Tags'
import Header from '../../../Components/Header'
import Seo from '../../../Components/SeoComponent/Seo'
import { HeadTag, InputField } from '../../../Components/Tags/Tags'
import { showSuccessToast, showErrorToast } from '../../../utils/toastUtils'
import GaugeChart from 'react-gauge-chart'
import { checkTransUnionReport2,V2VerifyMobile } from '../../../Services/EquifaxCScore/highmark'
import TransUnionReportModal2 from './TransUnionReport'
import html2pdf from 'html2pdf.js';
import { TransUnionData2 } from './data'
import Loader from '../../../Loader'
import { fetchProfile } from '../../../Services/profile/profileservice'
import { FaHandPointLeft } from "react-icons/fa";
import { Link } from 'react-router-dom'


const TransUnionScore2 = () => {

  const [cusName, setCusName] = useState();
  const [lastName, setLastName] = useState();
  const [mobile, setMobile] = useState('');
  const [panNo, setPanNo] = useState('');
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [creditScore, setCreditScore] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalOpenMobile, setIsModalOpenMobile] = useState(false);
  const [mobileResponseData, setMobileResponseData] = useState(null);
  const [afterVerifyMobPan, setAfterVerifyMobPan] = useState('');
  const [triggerVerifyContine, setTriggerVerifyContinue] = useState('');
  const [profileData, setProfileData] = useState([]);
  const [TransUnionReport, setTransUnionReport] = useState(null); // Initialize with null
  const [Equifaxv2Error, setEquifaxv2Error] = useState(null);    // Put Null if no
  const [submittedName, setSubmittedName] = useState('');
  const [submittedMobile, setSubmittedMobile] = useState('');
  const [afterMobName, setAfterMobName] = useState('');
  const [afterVerifyDOBMob, setAfterVerifyDOBMob] = useState('');
  const [showLoader, setShowLoader] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);



  // NEW: Add state for score check mode
  const [scoreCheckMode, setScoreCheckMode] = useState('manual'); // 'direct' or 'manual'
  const [isMobileVerified, setIsMobileVerified] = useState(false);

  const [isVerifyDisabled, setIsVerifyDisabled] = useState(
    sessionStorage.getItem("verifyClicked") === "true"
  );
  const maxScore = 900;

  const validateForm = () => {
    const newErrors = {};

    // Validate customer name
    if (!cusName) {
      newErrors.cusName = 'First name is required.';
    }
    if (!lastName){
      newErrors.lastName = 'Last name is required';
    }

    if (mobile === "") {
      newErrors.mobile = 'Mobile number is required.';
    } else if (!/^[6-9]\d{9}$/.test(mobile)) {
      newErrors.mobile = 'Enter a valid 10-digit mobile number.';
    }

    if (panNo === "") {
      newErrors.panNo = 'PAN number is required.';
    } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panNo.toUpperCase())) {
      newErrors.panNo = 'Enter a valid PAN number (e.g., ABCDE1234F).';
    }

      // Manual mode mobile verification
    else if (scoreCheckMode === 'manual' && !isMobileVerified) {
    newErrors.mobile = 'Please verify mobile number first for manual check';
  }


    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handlesubmit = async () => {
    try {
      // Validate the form first
      const isValid = validateForm();
      if (!isValid) {
        setTransUnionReport(null);
        setEquifaxv2Error(null)
        showErrorToast('Please correct the form errors.');
        return; // Exit if validation fails
      }
      // Call the  function to submit data
      setShowLoader(true);
      await TransUinon2();

      setTimeout(() => {
        // Hide the loader after 1 second
        setShowLoader(false);
      }, 2000);
    } catch (error) {
      console.error('Error submitting data:', error);
      showErrorToast('Validate the Required Field');
      setShowLoader(false); // Hide loader in case of error
    }
  };



const handleDownloadPDF = () => {
  setIsDownloading(true);

  setTimeout(() => {
    const element = document.getElementById("CreditReport");
    const name = TransUnionReport?.name || Equifaxv2Error?.data?.name || Equifaxv2Error?.error?.name || "N/A";

    if (element) {
      element.classList.remove('hidden');

      // Clone the element
      const clonedElement = element.cloneNode(true);

      // Reset styles to avoid margin/padding issues
      clonedElement.style.margin = '0';
      clonedElement.style.padding = '0';
      clonedElement.style.position = 'relative';
      clonedElement.style.top = '0';
      clonedElement.style.left = '0';
      clonedElement.style.maxHeight = 'none';
      clonedElement.style.overflow = 'visible';
      clonedElement.style.width = '100%';

      // Optional: remove hidden class from all child elements
      clonedElement.querySelectorAll('.hidden').forEach(child => {
        child.classList.remove('hidden');
      });

      // Create temporary container
      const tempDiv = document.createElement('div');
      tempDiv.style.position = 'absolute';
      tempDiv.style.top = '0';
      tempDiv.style.left = '0';
      tempDiv.style.width = '100%';
      tempDiv.style.visibility = 'hidden';
      tempDiv.appendChild(clonedElement);
      document.body.appendChild(tempDiv);

      // Generate PDF
      html2pdf()
        .from(clonedElement)
        .set({
          margin: [0.2, 0.2, 0.2, 0.2], // top, left, bottom, right
          filename: `Experian_Credit_Report_${name}.pdf`,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2, backgroundColor: 'white' },
          jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
        })
        .save()
        .then(() => {
          document.body.removeChild(tempDiv);
          element.classList.add('hidden');
          setIsDownloading(false);
        })
        .catch(() => {
          showErrorToast("Failed to generate PDF");
          document.body.removeChild(tempDiv);
          element.classList.add('hidden');
          setIsDownloading(false);
        });
    } else {
      showErrorToast("No data found to download");
      setIsDownloading(false);
    }
  }, 10);
};



  //  TransUnion V2 Data
  async function TransUinon2() {
    try {
      setShowLoader(true);
      const payload = {
        "api_id": profileData?.user_id,
        "api_key": profileData?.api_key,
        "token_id": profileData?.token_id,
        "mobile": mobile,
        "first_name": cusName,
        "last_name": lastName,
        "pan": panNo,
      }

      const response = await checkTransUnionReport2(payload);
      setShowLoader(false);

       if (response.status === 403 && response.data.message === "Invalid or deactivated API key.") {
              setShowLoader(false);
              setIsLoading(false);
              showErrorToast("Invalid or deactivated API key.");
              return
            }
      
            if (response.status === 422 && response.data.message === "Insufficient balance in wallet.") {
              setShowLoader(false);
              setIsLoading(false);
              showErrorToast("Insufficient balance in wallet.");
              return
            }
            if (response.status === 422 && response.data.message === "User not authorized to access this service.") {
              setShowLoader(false);
              setIsLoading(false);
              showErrorToast("User not authorized to access this service.");
              return
            }

      if (response.status.code === 200) {
        setIsLoading(false);
        setTransUnionReport(response.data);
        setCreditScore(response.data.credit_score)
        setSubmittedName(cusName);
        setCusName('');
        setLastName('');
        setMobile('');
        setPanNo('');
        setIsLoading(false);
        setShowLoader(true);
         setIsMobileVerified(false); // Reset verification status
        showSuccessToast(response.message);

        return;
      } else {
         setEquifaxv2Error(response?.error || response?.data || {});  // Now capturing error block
        setTransUnionReport(null);
        setShowLoader(false);
        showErrorToast(
         response?.data?.message ||
        response?.message ||
          response?.data?.error?.credit_report_message?.message ||
          response?.error?.message ||
          response?.data?.error ||  
           "Something went wrong.");
      }
      return;
    } catch (error) {
      setTransUnionReport(null);
      console.error("Error in TranUnion:", error);
      setShowLoader(false);
       showErrorToast("Something went wrong.");
  } finally {
            setShowLoader(false);
            setIsLoading(false);
        }
  }
  // ENd

  useEffect(() => {
    async function fetchProfileData() {
      try {
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error('Error fetching profile data', error);
      }
    }
    fetchProfileData();
  }, []);


  const handleVerifyMobile = async () => {
    const newErrors = {};

    // Only validate mobile
    if (!mobile.trim()) {
      newErrors.mobile = "Mobile is required";
    }
    if (!cusName) {
      newErrors.cusName = "First name is required";
    }
    if (!lastName) {
      newErrors.lastName = "Last name is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      setShowLoader(true)
      setIsVerifyDisabled(true);
      sessionStorage.setItem("verifyClicked", "true");

      const payload = {
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        mobile_number: mobile,
        first_name: cusName,
        last_name: lastName,
      };

      const response = await V2VerifyMobile(payload);
      if (response.status === 403 && response.data.message === "Invalid or deactivated API key.") {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Invalid or deactivated API key.");
        return
      }
      if (response.status === 422 && response.data.message === "Insufficient balance.") {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Insufficient balance.");
        return
      }
      if (response.status === 422 && response.data.message === "User not authorized to access this service.") {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("User not authorized to access this service.");
        return
      }
      setMobileResponseData(response || response?.data || response?.data?.data);
      setMobile('');
      setCusName('');
      setLastName('');
      if (response?.data?.result !== null) {
        showSuccessToast(response?.status?.message || response?.message || "Consumer Details Fetched");
      } else {
        showErrorToast(response?.status?.message || response?.message || "No Records Found");
      }
      setShowLoader(false);
      setIsLoading(false);
      setIsVerifyDisabled(false);
      setIsModalOpenMobile(true);
    } catch (error) {
      console.error("Error verifying Consumer:", error);
      setIsVerifyDisabled(false);
      setShowLoader(false);
      setIsLoading(false);
    }
  };

  // Reset on page load
  useEffect(() => {
    sessionStorage.removeItem("verifyClicked");
  }, []);

  const VerifyContinue = () => {
    setTriggerVerifyContinue(true);
    setIsModalOpenMobile(false);
  };


    useEffect(() => {
      if (triggerVerifyContine) {
        if (afterMobName) {
          const name = afterMobName || '';
          const nameParts = name.trim().split(' ');
          const firstNameFromName = nameParts[0] || '';
          const lastNameFromName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';
          setCusName(firstNameFromName);
          setLastName(lastNameFromName);
        }
  
        // Reset trigger
        setTriggerVerifyContinue(false);
      }
    }, [triggerVerifyContine, afterVerifyMobPan, afterMobName]);
  
    // NEW: Handle mode change and reset verification status
    const handleModeChange = (mode) => {
      setScoreCheckMode(mode);
      setIsMobileVerified(false);
      setErrors({});
    };









  const responses = TransUnionReport &&  TransUnionReport?.credit_report[0].accounts;
  const idTypeMapPersonal = {
  SocialId: "Social Id",
  TaxId: "PAN",
  RationCardId: "Ration Card No",
  CkycId: "CKYC Id",
};



const buildYearlyHistory = (payStatusArray = []) => {
  const months = ["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"];
  const history = {};

  payStatusArray.forEach(item => {
    const date = new Date(item.date);
    const year = date.getFullYear();
    const monthIndex = date.getMonth();

    if (!history[year]) {
      history[year] = Array(12).fill("-");
    }

    history[year][monthIndex] = item.status || "000";
  });

  return { months, history };
};



  return (
    <>
      <Seo />
      {showLoader && <Loader />}

      <Header heading='TransUnion (CIBIL) V2 Credit Report' />




{/* NEW: Radio buttons for selecting score check mode */}
<DivTag className="flex justify-center items-center gap-6 bg-white mt-2 shadow-md rounded-md p-4">
  <HeadTag className="text-lg font-bold">Select Score Check Mode:</HeadTag>
  
  <label
  className="flex items-center gap-2 cursor-pointer">
  <input
    type="radio"
    name="scoreCheckMode"
    value="direct"
    checked={scoreCheckMode === 'direct'}
    onChange={() => handleModeChange('direct')}
    className="w-4 h-4 cursor-pointer"
  />
  <span className="text-md font-medium">
    Direct Score Check
  </span>
</label>

<label className="flex items-center gap-2 cursor-pointer">
  <input
    type="radio"
    name="scoreCheckMode"
    value="manual"
    checked={scoreCheckMode === 'manual'}
    onChange={() => handleModeChange('manual')}
    className="w-4 h-4 cursor-pointer"
  />
  <span className="text-md font-medium">
    Manual Score Check
  </span>
</label>
</DivTag>




      <DivTag className="container grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-5 gap-1 md:gap-2 p-2 bg-white  md:mt-1 mt-0 shadow-blue-600 rounded-md">

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif" >First Name<strong className='text-red-700'>*</strong></HeadTag>
          <input
            type='text'
            id="cus_name"
            name="cus_name"
            value={cusName}
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
            placeholder="Enter First Name"
            onChange={(e) => setCusName(e.target.value)}
          />
          {errors.cusName && <p className="text-red-600 text-sm font-mono">{errors.cusName}</p>}
        </DivTag>


        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif" >Last Name<strong className='text-red-700'>*</strong></HeadTag>
          <input
            type='text'
            id="last_name"
            name="last_name"
            value={lastName}
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
            placeholder="Enter Last Name"
            onChange={(e) => setLastName(e.target.value)}
          />
          {errors.lastName && <p className="text-red-600 text-sm font-mono">{errors.lastName}</p>}
        </DivTag>



  {/* Mobile Section */}
  <DivTag className="flex flex-col">
    <div className="flex items-center justify-between mb-1">
      <HeadTag className="text-md font-serif">
        Mobile <strong className="text-red-700">*</strong>
      </HeadTag>
      {scoreCheckMode === 'manual' && isMobileVerified && (
        <button
          type="button"
          onClick={() => setIsModalOpenMobile(true)}
          className="text-sm bg-green-600 text-white px-2 py-1 rounded hover:bg-green-700"
        >
          View Details
        </button>
      )}
    </div>

    <InputField
      type="text"
      placeholder="Enter Mobile"
      className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full"
      name="mobile"
      id="mobile"
      value={mobile}
      onChange={(e) => {
        setMobile(e.target.value);
        setIsMobileVerified(false); // Reset verification when mobile changes
      }}
    />

    {errors.mobile && (
      <p className="text-red-600 text-sm font-mono mt-1">{errors.mobile}</p>
    )}

    {isModalOpenMobile && (
      <MobileDataModal
        setAfterMobName={setAfterMobName}
        mobileResponseData={mobileResponseData}
        VerifyContinue={VerifyContinue}
        onClose={() => setIsModalOpenMobile(false)}
      />
    )}
  </DivTag>

         {scoreCheckMode !== 'manual' && (
  <DivTag className="flex flex-col">
    <HeadTag className="text-md font-serif">
      Pan No. <strong className="text-red-700">*</strong>
    </HeadTag>

    <InputField
      type="text"
      placeholder="Enter Pan"
      className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
      name="pan_no"
      id="pan_no"
      onChange={(e) => setPanNo(e.target.value)}
    />

    {errors.panNo && (
      <p className="text-red-600 text-sm font-mono">
        {errors.panNo}
      </p>
    )}
  </DivTag>
)}

{/* Conditional Button Rendering - Verify or Check Score */}
<div className="w-1/2">
  {scoreCheckMode === 'manual' && !isMobileVerified ? (
    // Show Verify Mobile button in Manual mode when not verified
    <button
      type="button"
      onClick={handleVerifyMobile}
      disabled={isVerifyDisabled}
      className={`rounded-md bg-green-600 text-white mt-7 mb-1 py-1 px-2 hover:bg-green-700 ${
        isVerifyDisabled ? 'opacity-50 cursor-not-allowed' : ''
      }`}
    >
      {isVerifyDisabled ? 'Verifying...' : 'Verify Mobile'}
    </button>
  ) : (
    // Show Check Score button in Direct mode or after verification in Manual mode
    <button
      className={`rounded-md bg-blue-700 text-white mt-7 mb-1 px-2 py-1 hover:bg-blue-800 ${
        isLoading ? 'opacity-50 cursor-not-allowed' : ''
      }`}
      onClick={handlesubmit}
      disabled={isLoading}
    >
      {isLoading ? 'Checking...' : 'Check Score'}
    </button>
  )}
</div>

      </DivTag>

      <div className='w-full text-center'>
        {errors.identification && <p className='text-red-600 text-sm font-mono'>{errors.identification}</p>}
      </div>

      {
        TransUnionReport || Equifaxv2Error ? (
          
          <div class="flex flex-col p-4 bg-white shadow-inner md:mt-1 shadow-blue-600 rounded-md">
            <span className='text-center font-bold md:text-xl'>Hey {TransUnionReport?.name || Equifaxv2Error?.data?.name || Equifaxv2Error?.error?.name}!</span>
            <h2 class="text-xl md:text-xl font-semibold text-center">Your TransUnion Credit Score</h2>

            <div class="flex flex-col md:flex-row justify-center md:justify-center gap-4 md:gap-8 md:mt-2 mt-3 relative">
              <div class="w-full md:w-[400px] relative md:mt-10">

                <span class="text-red-500 md:font-bold absolute md:top-[20px] md:left-10 md:mt-16 -rotate-70
    top-[60px] left-5 
    ">Poor</span>
                <span class="text-yellow-400 md:font-bold absolute md:left-[104px] md:mt-1 -rotate-26
    left-[69px] top-[-7px] 
    ">Average</span>
                <span class="text-orange-600 md:font-bold absolute md:left-60 md:mt-0 md:rotate-20
    left-[12rem] mt-[-9px] rotate-20
    ">Good</span>
                <span class="text-green-800 md:font-bold absolute md:top-[20px] md:ml-[19.5rem] md:mt-16 rotate-70
    ml-[16rem] mt-[3.5rem]
    ">Excellent</span>

                <GaugeChart
                  id="gauge-chart1"
                  nrOfLevels={3}
                  percent={creditScore / maxScore}  // Normalized value for gauge
                  needleColor={"#00008b"}
                  textColor={"transparent"}  // Hides the percentage text
                  needleBaseColor={"red"}
                  arcsLength={[0.3, 0.3, 0.3, 0.3]}
                  colors={['#cc0000', '#e6e600', '#cc6600', '#009900']}
                />
                <p class="text-black font-bold text-xl md:text-2xl absolute bottom-12 md:bottom-[5.5rem] 
      left-1/2 transform -translate-x-1/2">
                  {creditScore}
                </p>
              </div>

              <div class="flex flex-col items-center md:items-start">
                <ul class="text-left text-sm md:text-base space-y-1 mt-4">

                  <li><span class="font-bold">No of Accounts:</span>{TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.totalAccounts ? TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.totalAccounts : "N/A"}</li>
                  <li><span class="font-bold">Total Balance Amount:</span>{TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.currentBalance ? TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.currentBalance : "N/A"}</li>
                  <li><span class="font-bold">Total OverDue Accounts :</span>{TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.overdueAccounts ? TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.overdueAccounts : "N/A"}</li>
                  <li><span class="font-bold">Total OverDue Balance :</span>{TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.overdueBalance ? TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.overdueBalance : "N/A"}</li>
                  <li><span class="font-bold">Total Zero Balance  Account:</span>{TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.zeroBalanceAccounts ? TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.zeroBalanceAccounts : "N/A"}</li>
                </ul>
                <TransUnionReportModal2 isOpen={isModalOpen} onClose={() => setModalOpen(false)} TransUnionReport={TransUnionReport} submittedName={submittedName} submittedMobile={submittedMobile} />
                <div class="flex space-x-2 mt-4">
                  <button
                    onClick={() => setModalOpen(true)}
                    className="bg-blue-600 text-white text-sm md:text-base rounded-md px-2 py-1">
                    View Details
                  </button>
                  <button
                    className="bg-red-600 text-white text-sm md:text-base rounded-md px-2 py-1"
                    onClick={handleDownloadPDF}
                    disabled={isDownloading}
                  >
                    {isDownloading ? "Downloading..." : "Download"}
                  </button>
                </div>
              </div>

            </div>

          </div>
        ) : ""
      }

<div className='flex justify-center'>
        <div class="flex flex-col items-center bg-gray-200 rounded-md shadow-lg shadow-blue-800 md:w-3/4 w-full p-1">
          <h1 class="font-bold text-2xl text-red-600 underline mb-2">Instructions</h1>
          <h2 class="text-xl font-bold text-center text-gray-800 mb-2 underline">How to get Best Financial Credit Report in TransUnion (CIBIL) (V2)?</h2>
         
          <ul class="list-decimal list-inside text-left text-gray-700">
            <li className=''>Enter the correct First Name , Last Name.</li>
            <li>Enter the Mobile Number which is registered in credit bureau company.</li>
            <li>Enter the correct PAN Number.</li>
            <li>The TransUnion (CIBIL) credit Report only provide the details Report of that consumer which is available in the TransUnion(CIBIL) Bureau.</li>
            <li>If you didn’t get the report means you should try with different details or in another bureau company.</li>
          </ul>
        </div>
        </div>

      <>
        <div id="CreditReport" className="hidden bg-white rounded-lg shadow-lg w-full md:max-w-3xl overflow-y-auto max-h-[100vh]">
        <div className="a4-page">
          <div className="grid grid-cols-1 md:grid-cols-12">
            <div className="col-span-2">
              <img
                src="/assets/images/Trans.webp"
                className="w-24 p-1"
                alt="Company Logo"
              />
            </div>
            <div className="col-span-8 md:text-center text-center">
              <h4 className="text-xl font-bold"> TransUnion Credit Report</h4>
            </div>
            <div className="col-span-2 md:text-end text-end text-sm">
              Credit Score: <strong className="text-xl">
                {TransUnionReport?.credit_score}
              </strong>
            </div>
          </div>

          <div className="flex justify-between items-start flex-wrap">
            {/* Start section */}
            <div className="">
              <p className='text-xs'><i>Client ID:</i> <span className="client_id">{TransUnionReport?.client_id}</span></p>
              <p className='text-xs'><i>Report Order No:</i> <span className="report_order_no">{TransUnionReport?.credit_report[0]?.enquiries[0].index}</span></p>
            </div>

            {/* End section */}
            <div className="text-right">
                         <p className='text-xs'>
  <i className='font-semibold'>Date:</i>{" "}
  <span className="report_date">
    {TransUnionReport?.credit_report?.[0]?.scores?.[0]?.scoreDate || "N/A"}
  </span>
</p>
           
            </div>
          </div>

               <div className="flex flex-col items-center justify-center my-4">
                            {Equifaxv2Error && (
                   <div className="bg-red-50 border border-red-400 rounded-md p-1 w-full md:w-3/4">
                  <p className="text-center text-red-600 font-bold">
                    Error:{" "}
                    <span className="font-normal">
                      {
                        // Case 1: credit_report_message.message_code
                        Equifaxv2Error?.error?.credit_report_message?.message
                          ?.replace(/_/g, " ")
                          .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                          // Case 2: direct message
                          Equifaxv2Error?.message
                            ?.replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                          TransUnionReport?.message
                            ?.replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                          "Unknown Error"
                      }
                    </span>
                  </p>
                  <p className="text-center text-red-600 font-bold mt-1">
                    Code:{" "}
                    <span className="font-normal">
                      {
                        // Case 1: credit_report_message.message_code
                        Equifaxv2Error?.error?.credit_report_message?.message_code
                          ?.replace(/_/g, " ")
                          .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                          // Case 2: direct message_code
                          Equifaxv2Error?.message_code
                            ?.replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                          TransUnionReport?.message_code
                            ?.replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                          "Unknown code"
                      }
                    </span>
                  </p>
                </div>
                            )}
                        </div>



         <div className='flex justify-center'>
            <p className='font-bold text-black text-sm mb-2'>Personal Details</p>
          </div>

   <div className="border-2 p-2 rounded-md">
  {/* Personal Information Grid */}
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-1 mb-1">
    {/* Consumer Name */}
    <div className="text-[11px]">
      <span className="font-semibold text-gray-700">Consumer Name:</span>
      <span className="ml-1 text-gray-600">
        {TransUnionReport?.name ||
          Equifaxv2Error?.data?.name ||
          Equifaxv2Error?.name ||
          Equifaxv2Error?.error?.name ||
          "N/A"}
      </span>
    </div>

    {/* DOB */}
    <div className="text-[11px]">
      <span className="font-semibold text-gray-700">DOB:</span>
      <span className="ml-1 text-gray-600">
        {TransUnionReport?.credit_report[0]?.names[0]?.birthDate || "N/A"}
      </span>
    </div>

    {/* Gender */}
    <div className="text-[11px]">
      <span className="font-semibold text-gray-700">Gender:</span>
      <span className="ml-1 text-gray-600">
        {TransUnionReport?.credit_report[0]?.names[0]?.gender ||
          Equifaxv2Error?.data?.gender ||
          Equifaxv2Error?.gender ||
          Equifaxv2Error?.error?.gender ||
          "N/A"}
      </span>
    </div>

    {/* Mobile Numbers */}
    <div className="text-[11px]">
      <span className="font-semibold text-gray-700">Mobile:</span>
      <span className="ml-1 text-gray-600">
        {(() => {
          const phoneVariations =
            TransUnionReport?.credit_report[0]?.telephones ||
            Equifaxv2Error?.data?.mobile ||
            Equifaxv2Error?.mobile ||
            Equifaxv2Error?.error?.mobile;

          if (Array.isArray(phoneVariations) && phoneVariations.length > 0) {
            const numbers = phoneVariations
              .map((phoneDetail) => phoneDetail?.telephoneNumber)
              .filter(Boolean)
              .join(", ");
            return numbers || "N/A";
          } else if (phoneVariations && typeof phoneVariations === "object") {
            return phoneVariations?.telephoneNumber || "N/A";
          }
          return "N/A";
        })()}
      </span>
    </div>
  </div>

  {/* ID Documents Section */}
  {TransUnionReport?.credit_report[0]?.ids && 
   Array.isArray(TransUnionReport?.credit_report[0]?.ids) && 
   TransUnionReport?.credit_report[0]?.ids.length > 0 && (
    <div className="border-t border-cyan-200 pt-1">
      <p className="text-[11px] font-semibold text-gray-700 mb-1">ID Documents:</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-1">
        {TransUnionReport.credit_report[0].ids.map((idDetail, index) => (
          <div key={index} className="text-[11px] bg-gray-50 px-1 py-0 rounded">
            <span className="font-medium text-gray-700">
              {idTypeMapPersonal[idDetail?.idType] || idDetail?.idType}:
            </span>
            <span className="ml-1 text-gray-600">{idDetail?.idNumber}</span>
          </div>
        ))}
      </div>
    </div>
  )}
</div>



          <hr className="my-2" />
         <div className=" md:text-black text-black p-1 mt-1 rounded-tr-xl rounded-tl-xl text-xs font-semibold border">Reported Address</div>
          <table className="min-w-full table-auto border  text-left ">
            <thead className="">
              <tr className='text-[10px] md:text-cyan-500 text-cyan-500 font-semibold'>
                
                <th className="border md:text-cyan-500 text-cyan-500 px-1 py-0">Address</th>
                <th className="border md:text-cyan-500 text-cyan-500 px-1 py-0">Category</th>
                <th className="border md:text-cyan-500 text-cyan-500 px-1 py-0">Reported Date</th>
              </tr>
            </thead>
            <tbody className="address-info text-[10px]">
              {TransUnionReport && TransUnionReport?.credit_report[0]?.addresses?.length > 0 ?
                TransUnionReport?.credit_report[0]?.addresses?.map((singleAddress, index) => (
                  <tr key={index}>
                
                    <td className="border px-1">{singleAddress?.line1 || "N/A"}</td>
                    <td className="border px-1">{singleAddress?.addressCategory === '03' ? 'Permanent' : 'Residence' || "N/A"}</td>
                    <td className="border px-1">{singleAddress?.dateReported || "N/A"}</td>
                  </tr>
                ))
                :
                <tr>
                  <td colSpan="3" className="border border-black px-2 py-1 text-center">No address variations found</td>
                </tr>

              }
            </tbody>


          </table>


            {/* Credit Score Section */}
          <div className=" md:text-black p-1 text-black mt-2 rounded-tr-md rounded-tl-md text-xs border">CIBIL TRANSUNION SCORE(S)</div>
          <table className="min-w-full table-auto border text-left">
            <thead className="text-[11px] font-semibold text-cyan-500">
              <tr className='text-left text-sm'>
                <th className="border px-1 py-0">Score Name</th>
                <th className="border px-1 py-0">Scoring Elements</th>
                <th className="border px-1 py-0">Score</th>
              </tr>
            </thead>
            <tbody className="scoreDetailsInfo text-[11px]">
              {(() => {
                // Extract and normalize SCORE
                const scores = TransUnionReport?.credit_report[0]?.scores;
                const normalizedScores = Array.isArray(scores) ? scores : scores ? [scores] : [];

                // Render rows if scores are available
                return normalizedScores?.length > 0 ? (
                  normalizedScores?.map((scoreDetail, index) => (
                    <tr key={index}>
    <td className="border px-1 py-0">
      {scoreDetail?.scoreName || "N/A"}
    </td>
  
    <td className="border px-1 py-0">
      {scoreDetail?.scoreCardVersion || scoreDetail?.scoreCardName || "N/A"}
    </td>
      <td className="border px-1">
      <div className="flex flex-col items-center justify-center bg-green-300 rounded-lg border-green-700 border p-1 w-16 h-12">
        <span className="text-2xl font-bold text-blue-900">
          {scoreDetail?.score || "N/A"}
        </span>
        <span className="text-xs font-semibold text-cyan-600">Score</span>
      </div>
    </td>
  </tr>
                  ))
                ) : (
                  // Fallback row if no scores
                  <tr>
                    <td colSpan="3" className="border border-black px-2 py-1 text-center">No scores available</td>
                  </tr>
                );
              })()}
            </tbody>

          </table>

     
     <div className=" text-black p-1 mt-2 rounded-tr-md rounded-tl-md">
  Consumer Account Details
</div>


<table className="min-w-full table-auto text-left border-collapse">
  <tbody>
    {responses && Array.isArray(responses) && responses.length > 0 && (
      <tr>
        <td colSpan={6} className="px-1 py-0">

          {responses.map((LinkedAC, idx) => {
            
            // ✅ FIX: Build history inside loop
            const { months, history } = buildYearlyHistory(
              LinkedAC?.monthlyPayStatus || []
            );

            return (
              <>
              <span className='text-black text-xs'>{idx + 1}. Account</span>
              <div key={idx} className="mb-2 border rounded p-1 bg-white text-black shadow-sm">
                
                {/* Account Information */}
                <h5 className="font-semibold text-white p-2 text-xs rounded-tl-xl rounded-tr-xl flex flex-wrap gap-x-5 gap-y-1">
                  <span className="text-blue-600 text-sm">
                    Loan Type: <span className="text-black">{LinkedAC?.accountType}</span>
                  </span>

                  <span className="text-gray-300">|</span>

                  <span className="text-blue-600">
                    Open Date: <span className="text-black">{LinkedAC?.dateOpened}</span>
                  </span>

                  <span className="text-gray-300">|</span>

                  <span className="text-blue-600">
                    Date Closed: <span className="text-black">{LinkedAC?.dateClosed || "N/A"}</span>
                  </span>

                  <span className="text-gray-300">|</span>

                  <span className="text-blue-600">
                    Reported On: <span className="text-black">{LinkedAC?.dateReported}</span>
                  </span>
                </h5>

                {/* 3 MAIN COLUMNS */}
                <div className="grid grid-cols-3 md:grid-cols-3 gap-2 text-xs mt-1">

                  {/* ACCOUNT */}
                  <div className="border-r pr-3">
                    <h3 className="font-bold text-black mb-2 tracking-wide">ACCOUNT</h3>
                    <div className="space-y-1.5">
                      <p className="text-black"><span className="inline-block w-32 font-semibold text-cyan-500">Account Number:</span> {LinkedAC?.accountNumber}</p>
                      <p className="text-black"><span className="inline-block w-32 font-semibold text-cyan-500">Account Type:</span> {LinkedAC?.accountType}</p>
                      <p className="text-black"><span className="inline-block w-32 font-semibold text-cyan-500">Subscriber:</span> {LinkedAC?.memberShortName || "N/A"}</p>
                      <p className="text-black"><span className="inline-block w-32 font-semibold text-cyan-500">Last Payment:</span> {LinkedAC?.lastPaymentDate || "N/A"}</p>
                    </div>
                  </div>

                  {/* AMOUNTS */}
                  <div className="border-r px-3">
                    <h3 className="font-bold text-black mb-2 tracking-wide">AMOUNTS</h3>
                    <div className="space-y-1.5">
                      <p className="text-black"><span className="inline-block w-32 font-semibold text-cyan-500">Sanctioned:</span> ₹{LinkedAC?.highCreditAmount}</p>
                      <p className="text-black"><span className="inline-block w-32 font-semibold text-cyan-500">Credit Limit:</span> {LinkedAC?.creditLimit || "N/A"}</p>
                      <p className="text-black"><span className="inline-block w-32 font-semibold text-cyan-500">Interest Rate:</span> {LinkedAC?.interestRate || "N/A"}%</p>
                      <p className="text-black"><span className="inline-block w-32 font-semibold text-cyan-500">Tenure:</span> {LinkedAC?.termMonths} months</p>
                      <p className="text-black"><span className="inline-block w-32 font-semibold text-cyan-500">Current Balance:</span> ₹{LinkedAC?.currentBalance}</p>
                      <p className="text-black">
                        <span className="inline-block w-32 font-semibold text-cyan-500">Overdue:</span>
                        <span className={LinkedAC?.amountOverdue > 0 ? "text-red-600 font-bold" : "text-green-600"}>
                          ₹{LinkedAC?.amountOverdue || 0}
                        </span>
                      </p>
                      <p><span className="inline-block w-32 font-semibold text-cyan-500">Write-Off:</span> ₹{LinkedAC?.woAmountTotal || 0}</p>
                    </div>
                  </div>

                  {/* STATUS */}
                  <div className="px-3">
                    <h3 className="font-bold text-black mb-2 tracking-wide">STATUS</h3>
                    <div className="space-y-1.5">
                      <p>
                        <span className="inline-block w-32 font-semibold text-cyan-500">Status:</span>
                        <span className="text-green-600 font-bold">{LinkedAC?.accountStatus || "ACTIVE"}</span>
                      </p>
                    </div>
                  </div>

                </div>

                {/* PAYMENT HISTORY */}
                <div className="border mt-3 rounded-md overflow-hidden text-xs">

              

                  <div className="flex flex-wrap justify-between px-3 py-1 text-[10px] border-b bg-gray-100 text-blue-600 font-semibold">
                    <span className='text-sm text-black font-semibold'>DAYS PAST DUE / ASSET CLASSIFICATION</span>
                    <p className='text-cyan-500'>START DATE : <span className='text-black'> {LinkedAC?.dateOpened || "-"} </span></p>
                    <p className='text-cyan-500'>| END DATE : <span className='text-black'> {LinkedAC?.dateClosed || "-"} </span> </p>
                    <p className='text-cyan-500'>| LAST PAYMENT : <span className='text-black'> {LinkedAC?.lastPaymentDate || "-"} </span></p>
                  </div>

                  <div className="overflow-x-auto">
                    <table className="w-full text-center border-collapse">
                      <thead>
                        <tr className="bg-slate-50 border-b">
                          <th className="p-1 text-cyan-500 font-bold">YEAR</th>
                          {months.map((m, idx) => (
                            <th key={idx} className="p-1 text-cyan-500 font-semibold tracking-wide">{m}</th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {Object.keys(history)
                          .sort((a, b) => b - a)
                          .map((year, yIdx) => (
                            <tr key={yIdx} className="border-b hover:bg-gray-50">
                              <td className="p-1 font-bold text-cyan-500">{year}</td>

                              {history[year].map((value, mIdx) => (
                                <td key={mIdx} className="p-1">
                                  {value === "-" ? (
                                    <span className="text-gray-400">-</span>
                                  ) : (
                                    <span
                                      className={`font-semibold ${
                                        Number(value) > 30
                                          ? "text-yellow-600"
                                          : Number(value) > 0
                                          ? "text-green-700"
                                          : "text-gray-700"
                                      }`}
                                    >
                                      {value.padStart(3, "0")}
                                    </span>
                                  )}
                                </td>
                              ))}
                            </tr>
                          ))}
                      </tbody>

                    </table>
                  </div>
                </div>


                {/* LEGEND */}
                <div className="mt-2 flex flex-wrap gap-3 text-xs">
                  <div className="flex items-center gap-1"><span className="w-3 h-3 rounded-full bg-green-600 inline-block"></span> Standard (STD / 22 / 24 / 25)</div>
                  <div className="flex items-center gap-1"><span className="w-3 h-3 rounded-full bg-yellow-400 inline-block"></span> Past Due (32)</div>
                  <div className="flex items-center gap-1"><span className="w-3 h-3 rounded-full bg-red-600 inline-block"></span> Default (47 / 55)</div>
                  <div className="flex items-center gap-1"><span className="w-3 h-3 rounded-full bg-gray-500 inline-block"></span> Not Reported (0)</div>
                  <div className="flex items-center gap-1"><span className="w-3 h-3 rounded-full bg-blue-600 inline-block"></span> Special (XXX)</div>
                </div>

              </div>
              </>
            );
          })}
        </td>
      </tr>
    )}
  </tbody>
</table>







{/* Inquiry History Section */}
<div className="text-black p-1 mt-1 rounded-tr-md rounded-tl-md text-sm font-semibold">
  Inquiry History
</div>

<table className="min-w-full table-auto text-left border-collapse text-[10px]">
  <thead>
    <tr className="bg-gray-200">
      <th className="px-2 py-1 border">Member Name</th>
      <th className="px-2 py-1 border">Inquiry Date</th>
      <th className="px-2 py-1 border">Purpose</th>
      <th className="px-2 py-1 border">Amount</th>
      <th className="px-2 py-1 border">Remarks</th>
    </tr>
  </thead>
  <tbody>
    {Array.isArray(TransUnionReport?.credit_report[0]?.enquiries) &&
      TransUnionReport.credit_report[0].enquiries.map((inquiry, index) => {
        // Convert enquiryPurpose code to readable text
        let purposeText = "N/A";
        switch (inquiry.enquiryPurpose) {
          case "00":
            purposeText = "Other";
            break;
          case "05":
            purposeText = "Loan / Credit";
            break;
          // add more cases if needed
          default:
            purposeText = inquiry.enquiryPurpose;
        }

        return (
          <tr key={index} className="border text-gray-700 hover:bg-gray-100">
            <td className="border px-2 py-1 font-semibold text-cyan-500">
              {inquiry.memberShortName || "N/A"}
            </td>
            <td className="border px-2 py-1">{inquiry.enquiryDate || "N/A"}</td>
            <td className="border px-2 py-1 text-yellow-600">{purposeText}</td>
            <td className="border px-2 py-1 text-green-600 font-semibold">
              ₹{inquiry.enquiryAmount || "0"}
            </td>
            <td className="border px-2 py-1">
              {Array.isArray(inquiry?.REMARK) && inquiry.REMARK.length > 0
                ? inquiry.REMARK.join(", ")
                : "N/A"}
            </td>
          </tr>
        );

        
      })}
  </tbody>
</table>



          <div className="hidden md:text-black text-black p-1 mt-2 rounded-tr-md rounded-tl-md text-sm font-semibold">Account Summary</div>
          <div className="hidden gap-1">

            {/* Primary Accounts Summary Card */}
            <div className="bg-gray-200 p-2 rounded-lg shadow-lg">
              <h3 className="font-semibold text-sm mb-2 rounded-sm text-black text-center">Primary Accounts Summary</h3>
              <div className='text-[11px]'>
                <p className='border-b'><span className="font-semibold">Number of Accounts:</span> {TransUnionReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-NUMBER-OF-ACCOUNTS"]}</p>
                <p className='border-b'><span className="font-semibold">Active Accounts:</span> {TransUnionReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-ACTIVE-NUMBER-OF-ACCOUNTS"]}</p>
                <p className='border-b'><span className="font-semibold">Overdue Accounts:</span> {TransUnionReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-OVERDUE-NUMBER-OF-ACCOUNTS"]}</p>
                <p className='border-b'><spna className="font-semibold">Secured Accounts: </spna>{TransUnionReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-SECURED-NUMBER-OF-ACCOUNTS"]}</p>
                <p className='border-b'><spna className="font-semibold">Unsecured Accounts: </spna>{TransUnionReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-UNSECURED-NUMBER-OF-ACCOUNTS"]}</p>
                <p className='border-b'><span className="font-semibold">Current Balance:</span> ₹{TransUnionReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-CURRENT-BALANCE"]}</p>
                <p className='border-b'><span className="font-semibold">Sanctioned Amount:</span> ₹{TransUnionReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-SANCTIONED-AMOUNT"]}</p>
                <p className='border-b'><span className="font-semibold">Disbursed Amount:</span> ₹{TransUnionReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-DISBURSED-AMOUNT"]}</p>
              </div>
            </div>

            {/* Secondary Accounts Summary Card */}
            <div className="bg-gray-200  p-1 rounded-lg shadow-lg">
              <h3 className="font-semibold text-xs mb-2  rounded-sm text-black text-center">Secondary Accounts Summary</h3>
              <div>
                <p className='border-b'><span className="font-semibold">Number of Accounts:</span> {TransUnionReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["SECONDARY-ACCOUNTS-SUMMARY"]?.["SECONDARY-NUMBER-OF-ACCOUNTS"]}</p>
                <p className='border-b'><span className="font-semibold">Active Accounts:</span> {TransUnionReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["SECONDARY-ACCOUNTS-SUMMARY"]?.["SECONDARY-ACTIVE-NUMBER-OF-ACCOUNTS"]}</p>
                <p className='border-b'><span className="font-semibold">Overdue Accounts:</span> {TransUnionReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["SECONDARY-ACCOUNTS-SUMMARY"]?.["SECONDARY-OVERDUE-NUMBER-OF-ACCOUNTS"]}</p>
                <p className='border-b'><span className="font-semibold">Current Balance:</span> ₹{TransUnionReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["SECONDARY-ACCOUNTS-SUMMARY"]?.["SECONDARY-CURRENT-BALANCE"]}</p>
                <p className='border-b'><span className="font-semibold">Sanctioned Amount:</span> ₹{TransUnionReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["SECONDARY-ACCOUNTS-SUMMARY"]?.["SECONDARY-SANCTIONED-AMOUNT"]}</p>
                <p className='border-b'><span className="font-semibold">Disbursed Amount:</span> ₹{TransUnionReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["SECONDARY-ACCOUNTS-SUMMARY"]?.["SECONDARY-DISBURSED-AMOUNT"]}</p>
              </div>
            </div>

            {/* Derived Attributes Card */}
            <div className="bg-gray-300  p-2 rounded-lg shadow-lg">
              <h2 className="font-semibold text-sm mb-2 rounded-sm text-black text-center">Derived Attributes</h2>
              <div>
                <p className='border-b'><span className="font-semibold">Inquiries in Last 6 Months:</span> {TransUnionReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["INQUIRIES-IN-LAST-SIX-MONTHS"]}</p>
                <p className='border-b'><span className="font-semibold">Length of Credit History:</span> {TransUnionReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["LENGTH-OF-CREDIT-HISTORY-YEAR"]} Year, {TransUnionReport?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["LENGTH-OF-CREDIT-HISTORY-MONTH"]} Month</p>
                <p className='border-b'><span className="font-semibold">Average Account Age:</span> {TransUnionReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["AVERAGE-ACCOUNT-AGE-YEAR"]} Year, {TransUnionReport?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["AVERAGE-ACCOUNT-AGE-MONTH"]} Month</p>
                <p className='border-b'><span className="font-semibold">New Accounts in Last 6 Months:</span> {TransUnionReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["NEW-ACCOUNTS-IN-LAST-SIX-MONTHS"]}</p>
                <p className='border-b'><span className="font-semibold">New Delinquent Accounts in Last 6 Months:</span> {TransUnionReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["NEW-DELINQ-ACCOUNT-IN-LAST-SIX-MONTHS"]}</p>
              </div>
            </div>
          </div>


          {/* Recent Activity Section */}
          <div className=" md:text-black text-black p-1 mt-2 rounded-tr-md rounded-tl-md text-xs border">Recent Activity (Last 90 Days)</div>
          <table className="min-w-full table-auto border text-left">
            <thead className="bg-gray-100">
              <tr className='text-xs text-cyan-500'>
                <th className="border px-2 py-1">Total Inquiries</th>
                <th className="border px-2 py-1">InquiryPast30Days</th>
                <th className="border px-2 py-1">Inquiry Past 24Months</th>
                <th className="border px-2 py-1">Recent Inquiry date</th>
              </tr>
            </thead>
            <tbody className="recentActivity">
              <tr className="border border-black text-center text-xs">
                <td className="border px-2 py-1">{TransUnionReport && TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.inquirySummary?.totalInquiry?.TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.inquirySummary?.totalInquiry || "N/A"}</td>
                <td className="border px-2 py-1">{TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.inquirySummary?.inquiryPast30Days?.TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.inquirySummary?.inquiryPast30Days || "N/A"}</td>
                <td className="border px-2 py-1">{TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.inquirySummary?.inquiryPast24Months?.TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.inquirySummary?.inquiryPast24Months || "N/A"}</td>
                <td className="border px-2 py-1">{TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.inquirySummary?.recentInquiryDate?.TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.inquirySummary?.recentInquiryDate || "N/A"}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* Summary Section */}
        <div className=" md:text-black text-black p-1 mt-2 rounded-tr-md rounded-tl-md text-xs border">Summary</div>
        <table className="min-w-full table-auto border text-left">
          <thead className="bg-gray-100">
                   <tr className='text-xs text-cyan-500'>
              <th className='border px-2 py-1'>Number of Accounts</th>
              <th className='border px-2 py-1'>Total Balance Amount</th>
              <th className='border px-2 py-1'>High Credit Amount</th>
            </tr>
          </thead>
          <tbody class="summary1">
            <tr className='text-xs'>
              <td className='borde px-2 py-1'>{TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.totalAccounts?.TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.totalAccounts || "N/A"}</td>
              <td className='borde px-2 py-1'>
                
                <p className="underline font-bold text-greeen-600">
                {TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.currentBalance?.TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.currentBalance || "N/A"}
                </p>
                </td>
             
              <td className='border px-2 py-1'>
                {TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.highCreditAmount?.TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.highCreditAmount || "N/A"}
              </td>
            </tr>
          </tbody>
        </table>
        <table className="min-w-full table-auto border text-left">
          <thead className="bg-gray-100">
           <tr className='text-xs text-cyan-500'>
              <th className="border px-2 py-1">Number of Open Accounts</th>
              <th className="border px-2 py-1">Total Past Due Amount</th>
              <th className="border px-2 py-1">ZeroBalance Account</th>
            </tr>
          </thead>
          <tbody class="summary2">
                 <tr className='text-xs'>
              <td className='border px-2 py-1'>{TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.totalAccounts ? TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.totalAccounts : "N/A"}</td>
              <td className='border px-2 py-1 '>
                <p className="underline font-bold text-red-600">
                {TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.overdueBalance ? TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.overdueBalance : "N/A"}
                 </p>
                </td>
          
              <td className='border px-2 py-1'>{TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.zeroBalanceAccounts ? TransUnionReport?.credit_report[0]?.response?.consumerSummaryresp?.accountSummary?.zeroBalanceAccounts : "N/A"}</td>
            </tr>
          </tbody>
        </table>

        <table className="min-w-full hidden table-auto border text-left">
          <thead className="bg-gray-100">
            <tr className='text-xs text-cyan-500'>
              <th className="border border-black px-2 py-1">Total High Credit</th>
              <th className="border border-black px-2 py-1">Total Sanction Amount</th>
              <th className="border border-black px-2 py-1">Single Highest Sanction</th>
            </tr>
          </thead>
          <tbody class="summary2">
            <tr className='text-xs'>
              <td className='border border-black px-2 py-1'>{TransUnionReport?.[""]}</td>
              <td className='border border-black px-2 py-1'>{TransUnionReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-SANCTIONED-AMOUNT"]}</td>
              <td className='border border-black px-2 py-1'>{TransUnionReport?.[""]}</td>
            </tr>
          </tbody>
        </table>


  <div className="mt-2 border">
  <h4 className="text-md font-semibold text-gray-700 mb-2 px-2">
    CIR DATA GLOSSARY
  </h4>

  <div className="grid grid-cols-3 sm:grid-cols-3 gap-1 text-[10px] bg-white p-2 rounded shadow">

    {/* Row - Report Name */}
    <div className="font-bold text-cyan-600 bg-gray-100 rounded-sm px-1 py-0">Report Section</div>
    <div className="font-bold text-cyan-600 bg-gray-100 rounded-sm px-1 py-0">Key Term / Code</div>
    <div className="font-bold text-cyan-600 bg-gray-100 rounded-sm px-1 py-0">Description</div>

    <div>Report name</div>
    <div>-</div>
    <div>Consumer CIR</div>

    {/* Row - Consumer Details */}
    <div>Consumer Details</div>
    <div>e</div>
    <div>Enriched through Enquiry</div>

    {/* Row - Identification */}
    <div>Identification(s)</div>
    <div>ID Types</div>
    <div>PAN, Passport, Voter ID, DL, Ration, UID</div>

    {/* Row - Telephone */}
    <div>Telephone(s)</div>
    <div>Telephone Types</div>
    <div>Latest 4 telephone details reported</div>

    {/* Row - Email */}
    <div>Email Contact(s)</div>
    <div>-</div>
    <div>Latest 4 emails reported</div>

    {/* Row - Employment */}
    <div>Employment Information(s)</div>
    <div>Occupation Codes</div>
    <div>Salaried, Self Employed, Others</div>

    {/* Row - Address */}
    <div>Address(es)</div>
    <div>Address Category</div>
    <div>Latest 4 addresses: Permanent, Residence, Office</div>

    {/* Row - Account Status */}
    <div>Consumer Account Details</div>
    <div>Account Information</div>
    <div>Active = Not closed, Inactive = Closed</div>

    {/* Row - DPD */}
    <div>Consumer Account Details</div>
    <div>DPD / Asset Classification</div>
    <div>STD, SMA, SUB, DBT, LSS, 000-900, XXX</div>

    {/* Row - Dispute */}
    <div>Consumer Account Details</div>
    <div>Information under dispute</div>
    <div>Grievance raised by consumer regarding correctness</div>

    {/* Row – Enquiry */}
    <div>Enquiry Details</div>
    <div>-</div>
    <div>Enquiries made with other members</div>

  </div>
</div>



     <div className='mt-4'>
  <h3 className="text-green-800 text-center font-bold">END of Report  {" "}
                  :{" "}
                  {TransUnionReport?.name ||
                    Equifaxv2Error?.data?.name ||
                    Equifaxv2Error?.name ||
                    Equifaxv2Error?.error?.name ||
                    "N/A"}</h3>
</div>

        </div>
      </>

    </>
  )
}

export default TransUnionScore2





const MobileDataModal = ({
  mobileResponseData,
  onClose,
  setAfterVerifyMobPan,
  setAfterMobName,
  setAfterVerifyDOBMob,
  VerifyContinue
}) => {
  const rootData = mobileResponseData?.data || {};

  // Use useEffect to set the data properly
  useEffect(() => {
    if (rootData) {
      setAfterMobName(rootData?.name || "");
      setAfterVerifyMobPan(rootData?.pan || "");
      setAfterVerifyDOBMob(rootData?.dob || "");
    }
  }, [rootData, setAfterMobName, setAfterVerifyMobPan, setAfterVerifyDOBMob]);

  const addresses = rootData?.address || [];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-3 rounded-lg shadow-2xl w-[90%] max-w-3xl max-h-[95vh] overflow-y-auto space-y-1">
        <div className='flex justify-between'>
          <h2 className="text-2xl font-bold text-blue-700 border-b">Consumer Verification Details</h2>
          <button onClick={onClose} className="text-2xl text-red-600 hover:text-red-800">❌</button>
        </div>


        {rootData?.name && (
          <div className="w-full flex flex-col items-center mb-2">
            <h3 className='text-xl text-green-600 font-semibold text-center'>Found In Experian</h3>
            <Link
              to="/ExperianScore2"
              className="flex items-center bg-green-700 hover:bg-green-800 text-white font-semibold py-2 px-4 gap-2 rounded transition duration-300 text-sm sm:text-base"
            >
              Result Found in Experian, Check Credit details in Experian for better result
              <FaHandPointLeft className="text-lg" />
            </Link>
          </div>
        )}


        {rootData?.idspay_message && (
          <div
            className={`flex justify-center border-2 p-1 rounded-lg ${rootData.idspay_message === 'success' ? 'bg-green-100 border-green-300' : 'bg-red-100 border-red-300'
              }`}
          >
            <p
              className={`text-md font-serif ${rootData.idspay_message === 'success' ? 'text-green-600' : 'text-red-500'
                }`}
            >
              {rootData.idspay_message}
            </p>
          </div>
        )}
        {/* Personal Info */}
        <div className="bg-blue-50 p-2 rounded-md shadow">
          <h3 className="text-lg font-semibold text-blue-600 mb-1">Personal Info</h3>
          <div className="grid grid-cols-2 gap-1 text-sm">
            <p><strong>Full Name:</strong> {rootData?.name || "N/A"}</p>
            <p><strong>DOB:</strong> {rootData?.dob || "N/A"}</p>
            <p><strong>Gender:</strong> {rootData?.gender || "N/A"}</p>
            <p><strong>PAN:</strong> {rootData?.pan || "N/A"}</p>
            <p><strong>Email:</strong> {rootData?.email || "N/A"}</p>
          </div>
        </div>

        {/* Addresses */}
        <div className="bg-yellow-50 p-2 rounded-md shadow">
          <h3 className="text-lg font-semibold text-yellow-600 mb-2">Addresses</h3>
          {addresses.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="w-full text-sm border border-gray-300 rounded-md">
                <thead className="bg-yellow-100 text-gray-700">
                  <tr>
                    <th className="border px-2 py-1 text-left">Address #</th>
                    <th className="border px-2 py-1 text-left">Full Address</th>
                    <th className="border px-2 py-1 text-left">State</th>
                    <th className="border px-2 py-1 text-left">Postal Code</th>
                  </tr>
                </thead>
                <tbody>
                  {addresses.map((address, index) => (
                    <tr key={index} className="border-t">
                      <td className="border px-2 py-1">Address {index + 1}</td>
                      <td className="border px-2 py-1">
                        {[address.first_line_of_address, address.second_line_of_address, address.third_line_of_address]
                          .filter(Boolean)
                          .join(', ')}
                      </td>
                      <td className="border px-2 py-1">{address.state || 'N/A'}</td>
                      <td className="border px-2 py-1">{address.postal_code || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-sm">No address information available.</p>
          )}
        </div>

        {/* Footer Buttons */}
        <div className='flex justify-center gap-3 mt-3'>
          <button
            onClick={VerifyContinue}
            className="bg-green-500 text-white px-4 py-1 rounded-md hover:bg-green-600 transition"
          >
            Verify & Continue
          </button>
          <button
            onClick={onClose}
            className="bg-red-500 text-white px-4 py-1 rounded-md hover:bg-red-600 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};









